module.exports = __webpack_public_path__ + "static/media/check-icon.0d7679e7.svg";